import { render, staticRenderFns } from "./AboutYourself.vue?vue&type=template&id=701ffeb8&scoped=true"
import script from "./AboutYourself.vue?vue&type=script&lang=js"
export * from "./AboutYourself.vue?vue&type=script&lang=js"
import style0 from "./AboutYourself.vue?vue&type=style&index=0&id=701ffeb8&prod&lang=scss"
import style1 from "./AboutYourself.vue?vue&type=style&index=1&id=701ffeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ffeb8",
  null
  
)

export default component.exports